import { render } from "./SupportModal.vue?vue&type=template&id=6a6e8dcc&lang=pug"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sellerofhappiness/WORK/VUE/CORAL VUE/components-store-v2/AUTH-FORM-CARD/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__